import { pbQuery } from "@sergio9929/pb-query";
import { queryOptions } from "@tanstack/react-query";
import { pb } from "@/lib/pocketbase";
import type { SafeOmit } from "@/lib/utils";
import {
	Collections,
	type DevicesResponse,
	type PlansResponse,
	type SubscriptionsResponse,
} from "@/types/pocketbase.ts";

export const fullListDevicesQueries = queryOptions({
	queryKey: [Collections.Devices, "fullList"],
	queryFn: () => {
		const query = pbQuery<DevicesResponse>()
			.sort(["-created"])
			.build((raw, params) => pb.filter(raw, params));

		return pb.collection(Collections.Devices).getFullList(query);
	},
});

type ExpandPlan = {
	plan: PlansResponse;
};

type Query = SafeOmit<SubscriptionsResponse, "plan"> & ExpandPlan;

type SubscriptionWithPlan = SubscriptionsResponse<ExpandPlan>;

export const getCurrentSubscriptionQuery = ({ doctorId }: { doctorId?: string }) =>
	queryOptions({
		queryKey: [Collections.Subscriptions, doctorId],
		queryFn: () => {
			if (!doctorId) throw new Error("No doctor ID found");

			const query = pbQuery<Query>()
				.expand(["plan"])
				.equal("doctor", doctorId)
				.build((raw, params) => pb.filter(raw, params));

			return pb.collection<SubscriptionWithPlan>(Collections.Subscriptions).getFirstListItem(query.filter, {
				query,
			});
		},
		enabled: !!doctorId,
	});
